import { inject, Injectable } from '@angular/core';
import { ApiHelper, ApiService, HttpResponse, HttpStatusEnum } from '@core/api';
import { ForwardMessagePayload, MessageResponse } from '@shared/types';
import { MessageMapper } from './message.mapper';

@Injectable({ providedIn: 'root' })
export class MessageApi {
    private apiService = inject(ApiService);

    getMessages(payload: any): Promise<HttpResponse<MessageResponse>> {
        return new Promise<HttpResponse<MessageResponse>>(resolve => {
            this.apiService.post('messages/get-messages', payload).subscribe({
                next: (res: any) => {
                    resolve(MessageMapper.mapGetMessages(res));
                },
                error: err => {
                    ApiHelper.resolveError(resolve, '');
                    console.error(err);
                },
            });
        });
    }

    forwardMessage(payload: ForwardMessagePayload): Promise<HttpResponse<void>> {
        return new Promise<HttpResponse<void>>(resolve => {
            this.apiService.post('messages/forward-message', payload).subscribe({
                next: () => {
                    resolve({ data: null, status: HttpStatusEnum.SUCCESS });
                },
                error: err => {
                    ApiHelper.resolveError(resolve, '');
                    console.error(err);
                },
            });
        });
    }
}
